export enum ProductAddOnsUITypeEnum {
  RADIO = 'radio',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  AUTOBILLING = 'auto-charging',
  AUTO_CHARGING = 'auto_charging',
}
